





























































import Vue from 'vue';

export default Vue.extend({
  name: 'Messages',
  computed: {
    messages() {
      return this.$store.state.messages;
    }
  }
});
